<template>
  <div>
    <h1>Makercart Analytics</h1>
  </div>
</template>

<style scoped></style>
